import {useNavigate} from "react-router-dom"
import {useDispatch} from "react-redux"
import {updateModalProduct} from "redux/actions/product"

export default function useHideProductDescriptionModal() {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  function handleHideProductDescription() {
    dispatch(updateModalProduct(undefined))
    const params = new URLSearchParams(window.location.search)
    params.delete("item")
    const search = params.toString()
    navigate({
      pathname: window.location.pathname,
      search: search ? `?${search}` : "",
    })
  }

  return handleHideProductDescription
}
